import React from "react";

function EditVehicleModal({ editForm, setEditForm, setEditVehicle, handleEditSubmit }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h3 className="text-lg font-semibold mb-4">Edit Vehicle</h3>
        <form onSubmit={handleEditSubmit}>
          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700">Model</label>
            <input
              type="text"
              value={editForm.model}
              onChange={(e) => setEditForm({ ...editForm, model: e.target.value })}
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700">Year</label>
            <input
              type="number"
              min="1980"
              max="2099"
              value={editForm.year}
              onChange={(e) =>
                setEditForm({ ...editForm, year: parseInt(e.target.value) || "" })
              }
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700">Type</label>
            <select
              value={editForm.type}
              onChange={(e) => setEditForm({ ...editForm, type: e.target.value })}
              required
              className="w-full p-2 border rounded"
            >
              <option value="">Select Type</option>
              <option value="Sedan">Sedan</option>
              <option value="SUV">SUV</option>
              <option value="Hatchback">Hatchback</option>
              <option value="Van">Van</option>
              <option value="Ute">Ute</option>
              <option value="Truck">Truck</option>
              <option value="Convertible">Convertible</option>
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700">
              Price Per Day ($)
            </label>
            <input
              type="number"
              min="0"
              step="1"
              value={editForm.price_per_day}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  price_per_day: parseFloat(e.target.value) || "",
                })
              }
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Image URL</label>
            <input
              type="text"
              value={editForm.image_url}
              onChange={(e) => setEditForm({ ...editForm, image_url: e.target.value })}
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Seats</label>
            <input
              type="number"
              min="1"
              max="20"
              value={editForm.seats || ""}
              onChange={(e) => setEditForm({ ...editForm, seats: parseInt(e.target.value) || "" })}
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => setEditVehicle(null)}
              className="mr-2 px-4 py-2 bg-gray-300 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditVehicleModal;
